import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAgent } from '../../../context/AgentContext';
import { cn } from '../../../lib/utils';
import DueQueue from './DueQueue';
import ContactLogTab from './ContactLogTab';
import BatchLogTab from './BatchLogTab';
import { TABS, tabFromSearch } from './trackerView';

const DESCRIPTIONS = {
  queue: (agent) => (agent
    ? `${agent}'s queue, ranked by who most needs a contact right now.`
    : 'Choose a VIP manager in the top bar.'),
  log: () => 'Every contact logged, newest first. Use the filter icon beside a player to see only their history.',
  batch: () => 'Log one outreach for many players at once. Send offers through Customer.io or by hand; this is only the log.',
};

function Tabs({ tab, onChange }) {
  return (
    <nav aria-label="Contact tracker" className="flex gap-1 border-b border-white/10">
      {TABS.map((t) => (
        <button
          key={t.key} type="button" aria-current={tab === t.key ? 'page' : undefined} onClick={() => onChange(t.key)}
          className={cn('-mb-px border-b-2 px-4 py-3 text-sm font-bold',
            tab === t.key ? 'border-cta text-ink' : 'border-transparent text-ink-dim hover:text-ink')}
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}

function Header({ description, aside }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h2 className="text-[26px] font-bold tracking-tight">Contact Tracker</h2>
        <p className="mt-1.5 text-sm text-ink-dim">{description}</p>
      </div>
      {aside}
    </div>
  );
}

// ContactTrackerPage: the contact queue (default), the contact log and the batch log, as tabs in
// the URL (?tab=log, ?tab=batch). The queue puts its coverage and "Work the queue" in the header.
export default function ContactTrackerPage() {
  const { selectedAgent: agent } = useAgent();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = tabFromSearch(searchParams);
  // Switching tabs drops the other tab's filters.
  const changeTab = (next) => setSearchParams(next === 'queue' ? {} : { tab: next }, { replace: true });
  const top = (aside) => (
    <div className="space-y-5">
      <Header description={DESCRIPTIONS[tab](agent)} aside={aside} />
      <Tabs tab={tab} onChange={changeTab} />
    </div>
  );

  return (
    <div className="mx-auto max-w-[1440px] space-y-5">
      {tab === 'queue' && (agent ? <DueQueue agent={agent} renderHeader={top} /> : top(null))}
      {tab !== 'queue' && top(null)}
      {tab === 'log' && <ContactLogTab agent={agent} />}
      {tab === 'batch' && <BatchLogTab />}
    </div>
  );
}
